import React from 'react';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../../../shared/lib/toggleModalVisble';
import { Button, Icon } from 'antd';
import styles from './ChangeEntity.module.scss';

const ChangeEntity = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.addShutdownInitiators,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Button
      ghost
      className={styles.root}
      onClick={handleClick}
      style={{ marginTop: '8px' }}
    >
      <Icon
        type="edit"
        className={styles.icon}
      />
      Изменить инициаторов
    </Button>
  );
};

export default ChangeEntity;
